import ScheduledMessagesList from './ScheduledMessagesList';

export default ScheduledMessagesList;
